import { motion } from 'framer-motion';
import React from 'react';
// import { NavLink } from 'react-router-dom'
import styled from 'styled-components';

const Box = styled(motion.a)`
	width: calc(10rem + 15vw);
	text-decoration: none;
	height: 20rem;
	padding: 1rem;
	color: ${(props) => props.theme.text};
	border: 2px solid ${(props) => props.theme.text};
	backdrop-filter: blur(2px);
	box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
	cursor: pointer;

	display: flex;
	flex-direction: column;
	z-index: 5;
`;

const Image = styled.div`
	background-image: ${(props) => `url(${props.img})`};
	width: 100%;
	height: 80%;
	background-size: cover;
	border: 1px solid transparent;
	background-position: center center;
`;
const Title = styled.h3`
	color: inherit;
	padding: 0.5rem 0;
	padding-top: 1rem;
	font-family: 'Karla', sans-serif;
	font-weight: 700;
	border-bottom: 1px solid ${(props) => props.theme.text};
`;
const HashTags = styled.div`
	padding: 0.5rem 0;
`;
const Tag = styled.span`
	padding-right: 0.5rem;
`;
const Date = styled.span`
	padding: 0.5rem 0;
`;

const Container = styled(motion.div)``;

// Framer motion configuration
const Item = {
	hidden: {
		scale: 0,
	},
	show: {
		scale: 1,
		transition: {
			type: 'spring',
			duration: 0.5,
		},
	},
};

const BlogComponent = (props) => {
	const { name, tags, date, imgSrc, link } = props.blog;
	return (
		<Container variants={Item}>
			{/* <Box target="_blank" href={`${link}`}>
				<Image img={imgSrc} />
				<Title>{name}</Title>
				<HashTags>
					{tags.map((t, id) => {
						if (id == 0) {
							return <Tag key={id}>{t}</Tag>;
						}
						return <Tag key={id}>| {t}</Tag>;
					})}
				</HashTags>
				<p>A web application platform to conduct online quizzing contests</p>
				<Date>{date}</Date>
			</Box> */}

			{/* <ul class="cards">
				<li class="cards__item">
					<div class="card">
						<div class="card__image card__image--fence"></div>
						<div class="card__content">
							<div class="card__title">Flex</div>
							<p class="card__text">
								This is the shorthand for flex-grow, flex-shrink and flex-basis
								combined. The second and third parameters (flex-shrink and
								flex-basis) are optional. Default is 0 1 auto.{' '}
							</p>
							<button class="btn btn--block card__btn">Button</button>
						</div>
					</div>
				</li>
				<li class="cards__item">
					<div class="card">
						<div class="card__image card__image--river"></div>
						<div class="card__content">
							<div class="card__title">Flex Grow</div>
							<p class="card__text">
								This defines the ability for a flex item to grow if necessary.
								It accepts a unitless value that serves as a proportion. It
								dictates what amount of the available space inside the flex
								container the item should take up.
							</p>
							<button class="btn btn--block card__btn">Button</button>
						</div>
					</div>
				</li>
				<li class="cards__item">
					<div class="card">
						<div class="card__image card__image--record"></div>
						<div class="card__content">
							<div class="card__title">Flex Shrink</div>
							<p class="card__text">
								This defines the ability for a flex item to shrink if necessary.
								Negative numbers are invalid.
							</p>
							<button class="btn btn--block card__btn">Button</button>
						</div>
					</div>
				</li>
				<li class="cards__item">
					<div class="card">
						<div class="card__image card__image--flowers"></div>
						<div class="card__content">
							<div class="card__title">Flex Basis</div>
							<p class="card__text">
								This defines the default size of an element before the remaining
								space is distributed. It can be a length (e.g. 20%, 5rem, etc.)
								or a keyword. The auto keyword means "look at my width or height
								property."
							</p>
							<button class="btn btn--block card__btn">Button</button>
						</div>
					</div>
				</li>
			</ul> */}
		</Container>
	);
};

export default BlogComponent;
